module.exports = __webpack_public_path__ + "img/training-tn.7bf60bdf.jpg";